import React from 'react';

let binarySearchContent = {
                            'videos': {
                                 'intuition': 'https://youtube.com/embed/_PZSDxPg9Ds',
                                 'analysis': 'https://youtube.com/embed/OIQgJU-Xt3Q',
                                 'songAndCode': 'https://youtube.com/embed/xKLxQLJa-ZI',
                             },
                            'img': (
                                <img src={'./binarySearchImg.png'} style={{"width": "300px", "maxWidth": "100%"}} />
                            ),
                            'intuition': (
                                    <div style={{'paddingLeft':'10%','paddingRight':'10%',}}>
                                        <p>Binary search looks for a specific value, which we refer to as a key in a sorted list of values. For example, it could be looking for a specific word in a dictionary, the word in this situation is the key, and the dictionary is the sorted list (it is in alphabetical order).</p>
                                        <ul>
                                            <li>Binary search takes in 4 parameters or input values, a lower bound position (which it will not search below), and an upper bound position (which it will not search above), a sorted list of values, and a key to search for.</li>
                                            <li>If it finds the key it outputs the position of the key in the list.</li>
                                            <li>If it does not find the key, it indicates that it did not find it.</li>
                                        </ul>
                                    </div>
                            ),
                            'analysis': (
                                    <ul>
                                        <li>Learn the basics of big-O notation</li>
                                        <li>Determine why binary search uses <i>O(log<sub>2</sub>n)</i> or logarithmic time in its worst case</li>
                                        <li>Determine why binary search uses <i>O(1) </i>or constant extra memory in any case, i.e. it works in-place.</li>
                                        <li>Go through some implementation pitfalls and how to avoid them.</li>
                                        <li>Discuss applications.</li>
                                    </ul>                              
                            ),
                            'songAndCode': (
                                    <ul style={
                                            {'marginLeft': '5%', 'marginRight': '5%'}
                                    }>
                                        <li>Hear the 17-line, 1 minute 45 second binary search song:
                                            <ol>
                                                <li>The first part covers big-O analysis facts.</li>
                                                <li>The second covers the pseudocode which will help you program binary search in any programming language.</li>
                                            </ol>
                                        </li>
                                        <li>Watch me demonstrate how to use the song lyrics to implement the algorithm in Python, the most straightforward programming language (in my opinion).</li>
                                    </ul>
                                   
                            )
                
};

export default binarySearchContent;



// WEBPACK FOOTER //
// ./src/AlgoPageContent/binary-search/content.jsx